import { ApiResponseObject } from "../../types";
import { ministryRepo } from "./ministry.repo";
import {
  FilterSelectOption,
  IDetaljiOSkladistaPayload,
  IDetaljiZahtevaDozvolePayload,
  IDohvatiDokumentPayload,
  IMfIzdavanjeResenjaOOduzimanjuPayload,
  IMfIzdavanjeResenjaPayload,
  IMfMarkcieVraceneInsertUnistenjePayload,
  IMfMarkiceVraceneCreateOrUpdatePayload,
  IMfObradiZahtevZaDozvoluPayload,
  IMfObradiZahtevZaMarkicu,
  IMfSveMarkiceVracenihPayload,
  IMfSviZahteviZaMarkicuProps,
  IPoreskaDokumentDohvatiPayload,
  IZahtevMarkiceIdProps,
  IZahtevaDozvolePayload,
  MfinExciseLicenceRequestListPayload,
  MfinExciseStampRequestListPayload,
  MfinExciseWarehouseListPayload,
  MfinListaEvidentiranihAkciznihMarkicaPayload,
} from "./ministry.types";

class MinistryService {
  postMfSviZahteviZaMarkicu = (
    payload: Partial<MfinExciseStampRequestListPayload>
  ): Promise<ApiResponseObject<IMfSviZahteviZaMarkicuProps>> => {
    return ministryRepo.postMfSviZahteviZaMarkicu(payload);
  };

  postInformacijeNapravljenogZahtevaZaMarkicu = (
    payload: IZahtevMarkiceIdProps
  ) => {
    return ministryRepo.postInformacijeNapravljenogZahtevaZaMarkicu(payload);
  };

  postMfObradiZahtevZaMarkicu = (params: IMfObradiZahtevZaMarkicu) => {
    return ministryRepo.postMfObradiZahtevZaMarkicu(params);
  };

  postMfListaAkciznihSkladista = (payload: MfinExciseWarehouseListPayload) => {
    return ministryRepo.postMfListaAkciznihSkladista(payload);
  };

  postDetaljiOSkladistu = (payload: IDetaljiOSkladistaPayload) => {
    return ministryRepo.postDetaljiOSkladistu(payload);
  };

  postMfObradiZahtevZaDozvolu = (payload: IMfObradiZahtevZaDozvoluPayload) => {
    return ministryRepo.postMfObradiZahtevZaDozvolu(payload);
  };

  createMfListaAkciznihDozvola = (
    payload: MfinExciseLicenceRequestListPayload
  ) => {
    return ministryRepo.createMfListaAkciznihDozvola(payload);
  };

  createDetaljiZahtevaDozvole = (payload: IDetaljiZahtevaDozvolePayload) => {
    return ministryRepo.createDetaljiZahtevaDozvole(payload);
  };

  createDohvatiDokument = (payload: IDohvatiDokumentPayload) => {
    return ministryRepo.createDohvatiDokument(payload);
  };

  createDohvatiDokumentMfin = (payload: IDohvatiDokumentPayload) => {
    return ministryRepo.createDohvatiDokumentMfin(payload);
  };

  poreskaDohvatiDokument = (payload: IPoreskaDokumentDohvatiPayload) => {
    return ministryRepo.poreskaDohvatiDokument(payload);
  };

  createMfIzdavanjeResenja = (payload: IMfIzdavanjeResenjaPayload) => {
    return ministryRepo.createMfIzdavanjeResenja(payload);
  };

  createMfIzdavanjeResenjaOOduzimanju = (
    payload: IMfIzdavanjeResenjaOOduzimanjuPayload
  ) => {
    return ministryRepo.createMfIzdavanjeResenjaOOduzimanju(payload);
  };

  getOptions = (filters: FilterSelectOption[]) => {
    const newFilters = filters.map((option: FilterSelectOption) => {
      return { label: option.name, value: option.id };
    });
    return newFilters;
  };

  generisiDozvolaZahtevDokument = (payload: IZahtevaDozvolePayload) => {
    return ministryRepo.generisiDozvolaZahtevDokument(payload);
  };

  postMfSveMarkiceVracenih = (payload: IMfSveMarkiceVracenihPayload) => {
    return ministryRepo.postMfSveMarkiceVracenih(payload);
  };

  postMfMarkiceVraceneCreateOrUpdate = (
    payload: IMfMarkiceVraceneCreateOrUpdatePayload
  ) => {
    return ministryRepo.postMfMarkiceVraceneCreateOrUpdate(payload);
  };

  postMfMarkcieVraceneInsertUnistenje = (
    payload: IMfMarkcieVraceneInsertUnistenjePayload
  ) => {
    return ministryRepo.postMfMarkcieVraceneInsertUnistenje(payload);
  };

  postMfMarkiceVraceneDelete = (payload: { id: number }) => {
    return ministryRepo.postMfMarkiceVraceneDelete(payload);
  };

  getMfListaKategorijaZaZahtev = (brojZahteva: string) => {
    return ministryRepo.getMfListaKategorijaZaZahtev(brojZahteva);
  };

  postMfListaEvidentiranihAkciznihMarkica = (
    payload: MfinListaEvidentiranihAkciznihMarkicaPayload
  ) => {
    return ministryRepo.postMfListaEvidentiranihAkciznihMarkica(payload);
  };
}

export const ministryService = new MinistryService();
